'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoZap = exports.GoX = exports.GoVersions = exports.GoUnmute = exports.GoUnfold = exports.GoTriangleUp = exports.GoTriangleRight = exports.GoTriangleLeft = exports.GoTriangleDown = exports.GoTrashcan = exports.GoTools = exports.GoThreeBars = exports.GoTerminal = exports.GoTelescope = exports.GoTag = exports.GoSync = exports.GoStop = exports.GoSteps = exports.GoStar = exports.GoSquirrel = exports.GoSplit = exports.GoSignOut = exports.GoSignIn = exports.GoSettings = exports.GoServer = exports.GoSearch = exports.GoScreenNormal = exports.GoScreenFull = exports.GoRuby = exports.GoRss = exports.GoRocket = exports.GoRepo = exports.GoRepoPush = exports.GoRepoPull = exports.GoRepoForked = exports.GoRepoForcePush = exports.GoRepoClone = exports.GoRadioTower = exports.GoQuote = exports.GoQuestion = exports.GoPuzzle = exports.GoPulse = exports.GoPrimitiveSquare = exports.GoPrimitiveDot = exports.GoPodium = exports.GoPlus = exports.GoPlug = exports.GoPlaybackRewind = exports.GoPlaybackPlay = exports.GoPlaybackPause = exports.GoPlaybackFastForward = exports.GoPin = exports.GoPerson = exports.GoPencil = exports.GoPaintcan = exports.GoPackage = exports.GoOrganization = exports.GoOctoface = exports.GoNoNewline = exports.GoMute = exports.GoMoveUp = exports.GoMoveRight = exports.GoMoveLeft = exports.GoMoveDown = exports.GoMortarBoard = exports.GoMirror = exports.GoMilestone = exports.GoMicroscope = exports.GoMention = exports.GoMegaphone = exports.GoMarkdown = exports.GoMarkGithub = exports.GoMail = exports.GoMailReply = exports.GoMailRead = exports.GoLogoGithub = exports.GoLock = undefined;
exports.GoLocation = exports.GoListUnordered = exports.GoListOrdered = exports.GoLink = exports.GoLinkExternal = exports.GoLightBulb = exports.GoLaw = exports.GoKeyboard = exports.GoKey = exports.GoJumpUp = exports.GoJumpRight = exports.GoJumpLeft = exports.GoJumpDown = exports.GoJersey = exports.GoIssueReopened = exports.GoIssueOpened = exports.GoIssueClosed = exports.GoInfo = exports.GoInbox = exports.GoHubot = exports.GoHourglass = exports.GoHorizontalRule = exports.GoHome = exports.GoHistory = exports.GoHeart = exports.GoGraph = exports.GoGlobe = exports.GoGitPullRequest = exports.GoGitMerge = exports.GoGitCompare = exports.GoGitCommit = exports.GoGitBranch = exports.GoGist = exports.GoGistSecret = exports.GoGift = exports.GoGear = exports.GoFold = exports.GoFlame = exports.GoFileZip = exports.GoFileText = exports.GoFileSymlinkFile = exports.GoFileSymlinkDirectory = exports.GoFileSubmodule = exports.GoFilePdf = exports.GoFileMedia = exports.GoFileDirectory = exports.GoFileCode = exports.GoFileBinary = exports.GoEye = exports.GoEllipsis = exports.GoDiff = exports.GoDiffRenamed = exports.GoDiffRemoved = exports.GoDiffModified = exports.GoDiffIgnored = exports.GoDiffAdded = exports.GoDeviceMobile = exports.GoDeviceDesktop = exports.GoDeviceCamera = exports.GoDeviceCameraVideo = exports.GoDatabase = exports.GoDashboard = exports.GoDash = exports.GoCreditCard = exports.GoComment = exports.GoCommentDiscussion = exports.GoColorMode = exports.GoCode = exports.GoCloudUpload = exports.GoCloudDownload = exports.GoClock = exports.GoClippy = exports.GoCircuitBoard = exports.GoCircleSlash = exports.GoChevronUp = exports.GoChevronRight = exports.GoChevronLeft = exports.GoChevronDown = exports.GoChecklist = exports.GoCheck = exports.GoCalendar = exports.GoBug = exports.GoBrowser = exports.GoBroadcast = exports.GoBriefcase = exports.GoBookmark = exports.GoBook = exports.GoBeer = exports.GoArrowUp = exports.GoArrowSmallUp = exports.GoArrowSmallRight = exports.GoArrowSmallLeft = exports.GoArrowSmallDown = exports.GoArrowRight = exports.GoArrowLeft = exports.GoArrowDown = exports.GoAlignmentUnalign = exports.GoAlignmentAlignedTo = exports.GoAlignmentAlign = exports.GoAlert = undefined;

var _alert = require('./alert');

var _alert2 = _interopRequireDefault(_alert);

var _alignmentAlign = require('./alignment-align');

var _alignmentAlign2 = _interopRequireDefault(_alignmentAlign);

var _alignmentAlignedTo = require('./alignment-aligned-to');

var _alignmentAlignedTo2 = _interopRequireDefault(_alignmentAlignedTo);

var _alignmentUnalign = require('./alignment-unalign');

var _alignmentUnalign2 = _interopRequireDefault(_alignmentUnalign);

var _arrowDown = require('./arrow-down');

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _arrowLeft = require('./arrow-left');

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = require('./arrow-right');

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _arrowSmallDown = require('./arrow-small-down');

var _arrowSmallDown2 = _interopRequireDefault(_arrowSmallDown);

var _arrowSmallLeft = require('./arrow-small-left');

var _arrowSmallLeft2 = _interopRequireDefault(_arrowSmallLeft);

var _arrowSmallRight = require('./arrow-small-right');

var _arrowSmallRight2 = _interopRequireDefault(_arrowSmallRight);

var _arrowSmallUp = require('./arrow-small-up');

var _arrowSmallUp2 = _interopRequireDefault(_arrowSmallUp);

var _arrowUp = require('./arrow-up');

var _arrowUp2 = _interopRequireDefault(_arrowUp);

var _beer = require('./beer');

var _beer2 = _interopRequireDefault(_beer);

var _book = require('./book');

var _book2 = _interopRequireDefault(_book);

var _bookmark = require('./bookmark');

var _bookmark2 = _interopRequireDefault(_bookmark);

var _briefcase = require('./briefcase');

var _briefcase2 = _interopRequireDefault(_briefcase);

var _broadcast = require('./broadcast');

var _broadcast2 = _interopRequireDefault(_broadcast);

var _browser = require('./browser');

var _browser2 = _interopRequireDefault(_browser);

var _bug = require('./bug');

var _bug2 = _interopRequireDefault(_bug);

var _calendar = require('./calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _check = require('./check');

var _check2 = _interopRequireDefault(_check);

var _checklist = require('./checklist');

var _checklist2 = _interopRequireDefault(_checklist);

var _chevronDown = require('./chevron-down');

var _chevronDown2 = _interopRequireDefault(_chevronDown);

var _chevronLeft = require('./chevron-left');

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = require('./chevron-right');

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _chevronUp = require('./chevron-up');

var _chevronUp2 = _interopRequireDefault(_chevronUp);

var _circleSlash = require('./circle-slash');

var _circleSlash2 = _interopRequireDefault(_circleSlash);

var _circuitBoard = require('./circuit-board');

var _circuitBoard2 = _interopRequireDefault(_circuitBoard);

var _clippy = require('./clippy');

var _clippy2 = _interopRequireDefault(_clippy);

var _clock = require('./clock');

var _clock2 = _interopRequireDefault(_clock);

var _cloudDownload = require('./cloud-download');

var _cloudDownload2 = _interopRequireDefault(_cloudDownload);

var _cloudUpload = require('./cloud-upload');

var _cloudUpload2 = _interopRequireDefault(_cloudUpload);

var _code = require('./code');

var _code2 = _interopRequireDefault(_code);

var _colorMode = require('./color-mode');

var _colorMode2 = _interopRequireDefault(_colorMode);

var _commentDiscussion = require('./comment-discussion');

var _commentDiscussion2 = _interopRequireDefault(_commentDiscussion);

var _comment = require('./comment');

var _comment2 = _interopRequireDefault(_comment);

var _creditCard = require('./credit-card');

var _creditCard2 = _interopRequireDefault(_creditCard);

var _dash = require('./dash');

var _dash2 = _interopRequireDefault(_dash);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _database = require('./database');

var _database2 = _interopRequireDefault(_database);

var _deviceCameraVideo = require('./device-camera-video');

var _deviceCameraVideo2 = _interopRequireDefault(_deviceCameraVideo);

var _deviceCamera = require('./device-camera');

var _deviceCamera2 = _interopRequireDefault(_deviceCamera);

var _deviceDesktop = require('./device-desktop');

var _deviceDesktop2 = _interopRequireDefault(_deviceDesktop);

var _deviceMobile = require('./device-mobile');

var _deviceMobile2 = _interopRequireDefault(_deviceMobile);

var _diffAdded = require('./diff-added');

var _diffAdded2 = _interopRequireDefault(_diffAdded);

var _diffIgnored = require('./diff-ignored');

var _diffIgnored2 = _interopRequireDefault(_diffIgnored);

var _diffModified = require('./diff-modified');

var _diffModified2 = _interopRequireDefault(_diffModified);

var _diffRemoved = require('./diff-removed');

var _diffRemoved2 = _interopRequireDefault(_diffRemoved);

var _diffRenamed = require('./diff-renamed');

var _diffRenamed2 = _interopRequireDefault(_diffRenamed);

var _diff = require('./diff');

var _diff2 = _interopRequireDefault(_diff);

var _ellipsis = require('./ellipsis');

var _ellipsis2 = _interopRequireDefault(_ellipsis);

var _eye = require('./eye');

var _eye2 = _interopRequireDefault(_eye);

var _fileBinary = require('./file-binary');

var _fileBinary2 = _interopRequireDefault(_fileBinary);

var _fileCode = require('./file-code');

var _fileCode2 = _interopRequireDefault(_fileCode);

var _fileDirectory = require('./file-directory');

var _fileDirectory2 = _interopRequireDefault(_fileDirectory);

var _fileMedia = require('./file-media');

var _fileMedia2 = _interopRequireDefault(_fileMedia);

var _filePdf = require('./file-pdf');

var _filePdf2 = _interopRequireDefault(_filePdf);

var _fileSubmodule = require('./file-submodule');

var _fileSubmodule2 = _interopRequireDefault(_fileSubmodule);

var _fileSymlinkDirectory = require('./file-symlink-directory');

var _fileSymlinkDirectory2 = _interopRequireDefault(_fileSymlinkDirectory);

var _fileSymlinkFile = require('./file-symlink-file');

var _fileSymlinkFile2 = _interopRequireDefault(_fileSymlinkFile);

var _fileText = require('./file-text');

var _fileText2 = _interopRequireDefault(_fileText);

var _fileZip = require('./file-zip');

var _fileZip2 = _interopRequireDefault(_fileZip);

var _flame = require('./flame');

var _flame2 = _interopRequireDefault(_flame);

var _fold = require('./fold');

var _fold2 = _interopRequireDefault(_fold);

var _gear = require('./gear');

var _gear2 = _interopRequireDefault(_gear);

var _gift = require('./gift');

var _gift2 = _interopRequireDefault(_gift);

var _gistSecret = require('./gist-secret');

var _gistSecret2 = _interopRequireDefault(_gistSecret);

var _gist = require('./gist');

var _gist2 = _interopRequireDefault(_gist);

var _gitBranch = require('./git-branch');

var _gitBranch2 = _interopRequireDefault(_gitBranch);

var _gitCommit = require('./git-commit');

var _gitCommit2 = _interopRequireDefault(_gitCommit);

var _gitCompare = require('./git-compare');

var _gitCompare2 = _interopRequireDefault(_gitCompare);

var _gitMerge = require('./git-merge');

var _gitMerge2 = _interopRequireDefault(_gitMerge);

var _gitPullRequest = require('./git-pull-request');

var _gitPullRequest2 = _interopRequireDefault(_gitPullRequest);

var _globe = require('./globe');

var _globe2 = _interopRequireDefault(_globe);

var _graph = require('./graph');

var _graph2 = _interopRequireDefault(_graph);

var _heart = require('./heart');

var _heart2 = _interopRequireDefault(_heart);

var _history = require('./history');

var _history2 = _interopRequireDefault(_history);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _horizontalRule = require('./horizontal-rule');

var _horizontalRule2 = _interopRequireDefault(_horizontalRule);

var _hourglass = require('./hourglass');

var _hourglass2 = _interopRequireDefault(_hourglass);

var _hubot = require('./hubot');

var _hubot2 = _interopRequireDefault(_hubot);

var _inbox = require('./inbox');

var _inbox2 = _interopRequireDefault(_inbox);

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _issueClosed = require('./issue-closed');

var _issueClosed2 = _interopRequireDefault(_issueClosed);

var _issueOpened = require('./issue-opened');

var _issueOpened2 = _interopRequireDefault(_issueOpened);

var _issueReopened = require('./issue-reopened');

var _issueReopened2 = _interopRequireDefault(_issueReopened);

var _jersey = require('./jersey');

var _jersey2 = _interopRequireDefault(_jersey);

var _jumpDown = require('./jump-down');

var _jumpDown2 = _interopRequireDefault(_jumpDown);

var _jumpLeft = require('./jump-left');

var _jumpLeft2 = _interopRequireDefault(_jumpLeft);

var _jumpRight = require('./jump-right');

var _jumpRight2 = _interopRequireDefault(_jumpRight);

var _jumpUp = require('./jump-up');

var _jumpUp2 = _interopRequireDefault(_jumpUp);

var _key = require('./key');

var _key2 = _interopRequireDefault(_key);

var _keyboard = require('./keyboard');

var _keyboard2 = _interopRequireDefault(_keyboard);

var _law = require('./law');

var _law2 = _interopRequireDefault(_law);

var _lightBulb = require('./light-bulb');

var _lightBulb2 = _interopRequireDefault(_lightBulb);

var _linkExternal = require('./link-external');

var _linkExternal2 = _interopRequireDefault(_linkExternal);

var _link = require('./link');

var _link2 = _interopRequireDefault(_link);

var _listOrdered = require('./list-ordered');

var _listOrdered2 = _interopRequireDefault(_listOrdered);

var _listUnordered = require('./list-unordered');

var _listUnordered2 = _interopRequireDefault(_listUnordered);

var _location = require('./location');

var _location2 = _interopRequireDefault(_location);

var _lock = require('./lock');

var _lock2 = _interopRequireDefault(_lock);

var _logoGithub = require('./logo-github');

var _logoGithub2 = _interopRequireDefault(_logoGithub);

var _mailRead = require('./mail-read');

var _mailRead2 = _interopRequireDefault(_mailRead);

var _mailReply = require('./mail-reply');

var _mailReply2 = _interopRequireDefault(_mailReply);

var _mail = require('./mail');

var _mail2 = _interopRequireDefault(_mail);

var _markGithub = require('./mark-github');

var _markGithub2 = _interopRequireDefault(_markGithub);

var _markdown = require('./markdown');

var _markdown2 = _interopRequireDefault(_markdown);

var _megaphone = require('./megaphone');

var _megaphone2 = _interopRequireDefault(_megaphone);

var _mention = require('./mention');

var _mention2 = _interopRequireDefault(_mention);

var _microscope = require('./microscope');

var _microscope2 = _interopRequireDefault(_microscope);

var _milestone = require('./milestone');

var _milestone2 = _interopRequireDefault(_milestone);

var _mirror = require('./mirror');

var _mirror2 = _interopRequireDefault(_mirror);

var _mortarBoard = require('./mortar-board');

var _mortarBoard2 = _interopRequireDefault(_mortarBoard);

var _moveDown = require('./move-down');

var _moveDown2 = _interopRequireDefault(_moveDown);

var _moveLeft = require('./move-left');

var _moveLeft2 = _interopRequireDefault(_moveLeft);

var _moveRight = require('./move-right');

var _moveRight2 = _interopRequireDefault(_moveRight);

var _moveUp = require('./move-up');

var _moveUp2 = _interopRequireDefault(_moveUp);

var _mute = require('./mute');

var _mute2 = _interopRequireDefault(_mute);

var _noNewline = require('./no-newline');

var _noNewline2 = _interopRequireDefault(_noNewline);

var _octoface = require('./octoface');

var _octoface2 = _interopRequireDefault(_octoface);

var _organization = require('./organization');

var _organization2 = _interopRequireDefault(_organization);

var _package = require('./package');

var _package2 = _interopRequireDefault(_package);

var _paintcan = require('./paintcan');

var _paintcan2 = _interopRequireDefault(_paintcan);

var _pencil = require('./pencil');

var _pencil2 = _interopRequireDefault(_pencil);

var _person = require('./person');

var _person2 = _interopRequireDefault(_person);

var _pin = require('./pin');

var _pin2 = _interopRequireDefault(_pin);

var _playbackFastForward = require('./playback-fast-forward');

var _playbackFastForward2 = _interopRequireDefault(_playbackFastForward);

var _playbackPause = require('./playback-pause');

var _playbackPause2 = _interopRequireDefault(_playbackPause);

var _playbackPlay = require('./playback-play');

var _playbackPlay2 = _interopRequireDefault(_playbackPlay);

var _playbackRewind = require('./playback-rewind');

var _playbackRewind2 = _interopRequireDefault(_playbackRewind);

var _plug = require('./plug');

var _plug2 = _interopRequireDefault(_plug);

var _plus = require('./plus');

var _plus2 = _interopRequireDefault(_plus);

var _podium = require('./podium');

var _podium2 = _interopRequireDefault(_podium);

var _primitiveDot = require('./primitive-dot');

var _primitiveDot2 = _interopRequireDefault(_primitiveDot);

var _primitiveSquare = require('./primitive-square');

var _primitiveSquare2 = _interopRequireDefault(_primitiveSquare);

var _pulse = require('./pulse');

var _pulse2 = _interopRequireDefault(_pulse);

var _puzzle = require('./puzzle');

var _puzzle2 = _interopRequireDefault(_puzzle);

var _question = require('./question');

var _question2 = _interopRequireDefault(_question);

var _quote = require('./quote');

var _quote2 = _interopRequireDefault(_quote);

var _radioTower = require('./radio-tower');

var _radioTower2 = _interopRequireDefault(_radioTower);

var _repoClone = require('./repo-clone');

var _repoClone2 = _interopRequireDefault(_repoClone);

var _repoForcePush = require('./repo-force-push');

var _repoForcePush2 = _interopRequireDefault(_repoForcePush);

var _repoForked = require('./repo-forked');

var _repoForked2 = _interopRequireDefault(_repoForked);

var _repoPull = require('./repo-pull');

var _repoPull2 = _interopRequireDefault(_repoPull);

var _repoPush = require('./repo-push');

var _repoPush2 = _interopRequireDefault(_repoPush);

var _repo = require('./repo');

var _repo2 = _interopRequireDefault(_repo);

var _rocket = require('./rocket');

var _rocket2 = _interopRequireDefault(_rocket);

var _rss = require('./rss');

var _rss2 = _interopRequireDefault(_rss);

var _ruby = require('./ruby');

var _ruby2 = _interopRequireDefault(_ruby);

var _screenFull = require('./screen-full');

var _screenFull2 = _interopRequireDefault(_screenFull);

var _screenNormal = require('./screen-normal');

var _screenNormal2 = _interopRequireDefault(_screenNormal);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _server = require('./server');

var _server2 = _interopRequireDefault(_server);

var _settings = require('./settings');

var _settings2 = _interopRequireDefault(_settings);

var _signIn = require('./sign-in');

var _signIn2 = _interopRequireDefault(_signIn);

var _signOut = require('./sign-out');

var _signOut2 = _interopRequireDefault(_signOut);

var _split = require('./split');

var _split2 = _interopRequireDefault(_split);

var _squirrel = require('./squirrel');

var _squirrel2 = _interopRequireDefault(_squirrel);

var _star = require('./star');

var _star2 = _interopRequireDefault(_star);

var _steps = require('./steps');

var _steps2 = _interopRequireDefault(_steps);

var _stop = require('./stop');

var _stop2 = _interopRequireDefault(_stop);

var _sync = require('./sync');

var _sync2 = _interopRequireDefault(_sync);

var _tag = require('./tag');

var _tag2 = _interopRequireDefault(_tag);

var _telescope = require('./telescope');

var _telescope2 = _interopRequireDefault(_telescope);

var _terminal = require('./terminal');

var _terminal2 = _interopRequireDefault(_terminal);

var _threeBars = require('./three-bars');

var _threeBars2 = _interopRequireDefault(_threeBars);

var _tools = require('./tools');

var _tools2 = _interopRequireDefault(_tools);

var _trashcan = require('./trashcan');

var _trashcan2 = _interopRequireDefault(_trashcan);

var _triangleDown = require('./triangle-down');

var _triangleDown2 = _interopRequireDefault(_triangleDown);

var _triangleLeft = require('./triangle-left');

var _triangleLeft2 = _interopRequireDefault(_triangleLeft);

var _triangleRight = require('./triangle-right');

var _triangleRight2 = _interopRequireDefault(_triangleRight);

var _triangleUp = require('./triangle-up');

var _triangleUp2 = _interopRequireDefault(_triangleUp);

var _unfold = require('./unfold');

var _unfold2 = _interopRequireDefault(_unfold);

var _unmute = require('./unmute');

var _unmute2 = _interopRequireDefault(_unmute);

var _versions = require('./versions');

var _versions2 = _interopRequireDefault(_versions);

var _x = require('./x');

var _x2 = _interopRequireDefault(_x);

var _zap = require('./zap');

var _zap2 = _interopRequireDefault(_zap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GoAlert = _alert2.default;
exports.GoAlignmentAlign = _alignmentAlign2.default;
exports.GoAlignmentAlignedTo = _alignmentAlignedTo2.default;
exports.GoAlignmentUnalign = _alignmentUnalign2.default;
exports.GoArrowDown = _arrowDown2.default;
exports.GoArrowLeft = _arrowLeft2.default;
exports.GoArrowRight = _arrowRight2.default;
exports.GoArrowSmallDown = _arrowSmallDown2.default;
exports.GoArrowSmallLeft = _arrowSmallLeft2.default;
exports.GoArrowSmallRight = _arrowSmallRight2.default;
exports.GoArrowSmallUp = _arrowSmallUp2.default;
exports.GoArrowUp = _arrowUp2.default;
exports.GoBeer = _beer2.default;
exports.GoBook = _book2.default;
exports.GoBookmark = _bookmark2.default;
exports.GoBriefcase = _briefcase2.default;
exports.GoBroadcast = _broadcast2.default;
exports.GoBrowser = _browser2.default;
exports.GoBug = _bug2.default;
exports.GoCalendar = _calendar2.default;
exports.GoCheck = _check2.default;
exports.GoChecklist = _checklist2.default;
exports.GoChevronDown = _chevronDown2.default;
exports.GoChevronLeft = _chevronLeft2.default;
exports.GoChevronRight = _chevronRight2.default;
exports.GoChevronUp = _chevronUp2.default;
exports.GoCircleSlash = _circleSlash2.default;
exports.GoCircuitBoard = _circuitBoard2.default;
exports.GoClippy = _clippy2.default;
exports.GoClock = _clock2.default;
exports.GoCloudDownload = _cloudDownload2.default;
exports.GoCloudUpload = _cloudUpload2.default;
exports.GoCode = _code2.default;
exports.GoColorMode = _colorMode2.default;
exports.GoCommentDiscussion = _commentDiscussion2.default;
exports.GoComment = _comment2.default;
exports.GoCreditCard = _creditCard2.default;
exports.GoDash = _dash2.default;
exports.GoDashboard = _dashboard2.default;
exports.GoDatabase = _database2.default;
exports.GoDeviceCameraVideo = _deviceCameraVideo2.default;
exports.GoDeviceCamera = _deviceCamera2.default;
exports.GoDeviceDesktop = _deviceDesktop2.default;
exports.GoDeviceMobile = _deviceMobile2.default;
exports.GoDiffAdded = _diffAdded2.default;
exports.GoDiffIgnored = _diffIgnored2.default;
exports.GoDiffModified = _diffModified2.default;
exports.GoDiffRemoved = _diffRemoved2.default;
exports.GoDiffRenamed = _diffRenamed2.default;
exports.GoDiff = _diff2.default;
exports.GoEllipsis = _ellipsis2.default;
exports.GoEye = _eye2.default;
exports.GoFileBinary = _fileBinary2.default;
exports.GoFileCode = _fileCode2.default;
exports.GoFileDirectory = _fileDirectory2.default;
exports.GoFileMedia = _fileMedia2.default;
exports.GoFilePdf = _filePdf2.default;
exports.GoFileSubmodule = _fileSubmodule2.default;
exports.GoFileSymlinkDirectory = _fileSymlinkDirectory2.default;
exports.GoFileSymlinkFile = _fileSymlinkFile2.default;
exports.GoFileText = _fileText2.default;
exports.GoFileZip = _fileZip2.default;
exports.GoFlame = _flame2.default;
exports.GoFold = _fold2.default;
exports.GoGear = _gear2.default;
exports.GoGift = _gift2.default;
exports.GoGistSecret = _gistSecret2.default;
exports.GoGist = _gist2.default;
exports.GoGitBranch = _gitBranch2.default;
exports.GoGitCommit = _gitCommit2.default;
exports.GoGitCompare = _gitCompare2.default;
exports.GoGitMerge = _gitMerge2.default;
exports.GoGitPullRequest = _gitPullRequest2.default;
exports.GoGlobe = _globe2.default;
exports.GoGraph = _graph2.default;
exports.GoHeart = _heart2.default;
exports.GoHistory = _history2.default;
exports.GoHome = _home2.default;
exports.GoHorizontalRule = _horizontalRule2.default;
exports.GoHourglass = _hourglass2.default;
exports.GoHubot = _hubot2.default;
exports.GoInbox = _inbox2.default;
exports.GoInfo = _info2.default;
exports.GoIssueClosed = _issueClosed2.default;
exports.GoIssueOpened = _issueOpened2.default;
exports.GoIssueReopened = _issueReopened2.default;
exports.GoJersey = _jersey2.default;
exports.GoJumpDown = _jumpDown2.default;
exports.GoJumpLeft = _jumpLeft2.default;
exports.GoJumpRight = _jumpRight2.default;
exports.GoJumpUp = _jumpUp2.default;
exports.GoKey = _key2.default;
exports.GoKeyboard = _keyboard2.default;
exports.GoLaw = _law2.default;
exports.GoLightBulb = _lightBulb2.default;
exports.GoLinkExternal = _linkExternal2.default;
exports.GoLink = _link2.default;
exports.GoListOrdered = _listOrdered2.default;
exports.GoListUnordered = _listUnordered2.default;
exports.GoLocation = _location2.default;
exports.GoLock = _lock2.default;
exports.GoLogoGithub = _logoGithub2.default;
exports.GoMailRead = _mailRead2.default;
exports.GoMailReply = _mailReply2.default;
exports.GoMail = _mail2.default;
exports.GoMarkGithub = _markGithub2.default;
exports.GoMarkdown = _markdown2.default;
exports.GoMegaphone = _megaphone2.default;
exports.GoMention = _mention2.default;
exports.GoMicroscope = _microscope2.default;
exports.GoMilestone = _milestone2.default;
exports.GoMirror = _mirror2.default;
exports.GoMortarBoard = _mortarBoard2.default;
exports.GoMoveDown = _moveDown2.default;
exports.GoMoveLeft = _moveLeft2.default;
exports.GoMoveRight = _moveRight2.default;
exports.GoMoveUp = _moveUp2.default;
exports.GoMute = _mute2.default;
exports.GoNoNewline = _noNewline2.default;
exports.GoOctoface = _octoface2.default;
exports.GoOrganization = _organization2.default;
exports.GoPackage = _package2.default;
exports.GoPaintcan = _paintcan2.default;
exports.GoPencil = _pencil2.default;
exports.GoPerson = _person2.default;
exports.GoPin = _pin2.default;
exports.GoPlaybackFastForward = _playbackFastForward2.default;
exports.GoPlaybackPause = _playbackPause2.default;
exports.GoPlaybackPlay = _playbackPlay2.default;
exports.GoPlaybackRewind = _playbackRewind2.default;
exports.GoPlug = _plug2.default;
exports.GoPlus = _plus2.default;
exports.GoPodium = _podium2.default;
exports.GoPrimitiveDot = _primitiveDot2.default;
exports.GoPrimitiveSquare = _primitiveSquare2.default;
exports.GoPulse = _pulse2.default;
exports.GoPuzzle = _puzzle2.default;
exports.GoQuestion = _question2.default;
exports.GoQuote = _quote2.default;
exports.GoRadioTower = _radioTower2.default;
exports.GoRepoClone = _repoClone2.default;
exports.GoRepoForcePush = _repoForcePush2.default;
exports.GoRepoForked = _repoForked2.default;
exports.GoRepoPull = _repoPull2.default;
exports.GoRepoPush = _repoPush2.default;
exports.GoRepo = _repo2.default;
exports.GoRocket = _rocket2.default;
exports.GoRss = _rss2.default;
exports.GoRuby = _ruby2.default;
exports.GoScreenFull = _screenFull2.default;
exports.GoScreenNormal = _screenNormal2.default;
exports.GoSearch = _search2.default;
exports.GoServer = _server2.default;
exports.GoSettings = _settings2.default;
exports.GoSignIn = _signIn2.default;
exports.GoSignOut = _signOut2.default;
exports.GoSplit = _split2.default;
exports.GoSquirrel = _squirrel2.default;
exports.GoStar = _star2.default;
exports.GoSteps = _steps2.default;
exports.GoStop = _stop2.default;
exports.GoSync = _sync2.default;
exports.GoTag = _tag2.default;
exports.GoTelescope = _telescope2.default;
exports.GoTerminal = _terminal2.default;
exports.GoThreeBars = _threeBars2.default;
exports.GoTools = _tools2.default;
exports.GoTrashcan = _trashcan2.default;
exports.GoTriangleDown = _triangleDown2.default;
exports.GoTriangleLeft = _triangleLeft2.default;
exports.GoTriangleRight = _triangleRight2.default;
exports.GoTriangleUp = _triangleUp2.default;
exports.GoUnfold = _unfold2.default;
exports.GoUnmute = _unmute2.default;
exports.GoVersions = _versions2.default;
exports.GoX = _x2.default;
exports.GoZap = _zap2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/index.js
// module id = 1917
// module chunks = 0